import { ParsedUrlQuery } from 'querystring';

export function getBedsMin(query: ParsedUrlQuery) {
    if (query['beds_min']) {
        return query['beds_min'];
    }

    return '';
}
